<unh-simple-card theme="gray" class="payment-profile-card">
    <unh-generic-content-container>
        <unh-slot-left>
            <img
                class="flag-img" 
                [src]="'https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/card-flags/' + cardTypeData?.type + '.png'" [alt]="cardTypeData?.niceType">
        </unh-slot-left>

        <unh-slot-right>
            <p>
                Cartão&nbsp;de&nbsp;Crédito que termina com final 
                <strong>{{ paymentProfile.card_number_last_four }}</strong><br>
                <span class="card-obs">Cartão expira em
                    <strong>{{ paymentProfile.card_expiration }}</strong></span>
            </p>
        </unh-slot-right>
    </unh-generic-content-container>
</unh-simple-card>
